import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PurchaseSessionSliceState } from "../../types/store";
import { ProductWithPrice, PurchaseSession } from "../../types/stripe";

export const PURCHASE_SESSION_SLICE = 'purhcaseSession' as const;

const initialState: PurchaseSessionSliceState = {
  product: null,
  session: null,
}

export const purchaseSessionSlice = createSlice({
  name: PURCHASE_SESSION_SLICE,
  initialState: initialState,
  reducers: {
    selectedPurchaseSessionProduct: (
      state: PurchaseSessionSliceState,
      { payload: product }: PayloadAction<ProductWithPrice | null>
    ) => {
      state.product = product;
    },
    loadPurchaseSession: (
      state: PurchaseSessionSliceState,
      { payload: session }: PayloadAction<PurchaseSession>
    ) => {
      state.session = session;
    },
    resetPurchaseSession: (
      state: PurchaseSessionSliceState,
      { payload: _ }: PayloadAction<undefined>
    ) => {
      state.session = null;
    }
  }
});

export const {
  loadPurchaseSession,
  resetPurchaseSession,
  selectedPurchaseSessionProduct,
} = purchaseSessionSlice.actions;

export default purchaseSessionSlice.reducer;